<div class="labelInputWrapper" [ngClass]="{ row: layout === 'inline' }">
  @if (label) {
    <label [attr.for]="inputId" class="form-label" [ngClass]="{ 'col-form-label col-sm-2 text-sm-right': layout === 'inline' }">
      {{ label }}
      @if (showLabelInfo) {
        <i
          [ngbPopover]="labelInfoTemplate"
          triggers="mouseenter:mouseleave"
          style="margin-bottom: var(--space-x-10px)"
          class="far fa-circle-info tiny-tooltip"
          popoverClass="dark-popover"
        ></i>
      }
    </label>
  }
  <div [ngClass]="{ 'col-sm-10': layout === 'inline' }" class="inputWrapper">
    <div
      [ngClass]="{
        'has-clear': clearable,
        'has-children-toggle': enableChildrenPopover(),
        'input-group': prefix || suffix || prefixIcon || suffixIcon,
        'input-group-sm': (prefix || suffix || prefixIcon || suffixIcon) && this.size === 'small',
        'input-group-lg': (prefix || suffix || prefixIcon || suffixIcon) && this.size === 'large',
      }"
      [ngbPopover]="enableChildrenPopover() ? childrenPopover : null"
      [popoverClass]="childrenPopoverClass()"
      placement="bottom-right"
      [autoClose]="'outside'"
      triggers="manual"
      #childrenPopoverRef="ngbPopover"
    >
      @if (prefixIcon) {
        <span class="input-group-text prefix"><chitin-icon [icon]="prefixIcon" /></span>
      }
      @if (prefix) {
        <span class="input-group-text prefix">{{ prefix }}</span>
      }
      @switch (type) {
        @case ('date') {
          <ng-container [ngTemplateOutlet]="dateTemplate" />
        }
        @default {
          <ng-container [ngTemplateOutlet]="defaultTemplate" />
        }
      }
      @if (clearable && value && !isDisabled && !readonly) {
        <span
          class="form-control-clear"
          [class.pushedLeft]="enableChildrenPopover()"
          [class.inTextarea]="type === 'textArea'"
          (click)="clearAndEmit()"
          >×</span
        >
      }
      @if (suffixIcon) {
        <span class="input-group-text prefix"><chitin-icon [icon]="suffixIcon" /></span>
      }
      @if (suffix) {
        <span class="input-group-text suffix">{{ suffix }}</span>
      }
      @if (enableChildrenPopover()) {
        <div class="childrenPopoverToggle clickable" (click)="childrenPopoverRef.toggle(); childrenPopoverOpened.emit()">
          <chitin-icon style="display: inline" [icon]="childrenPopoverRef.isOpen() ? 'far fa-chevron-up' : 'far fa-chevron-down'" />
        </div>
      }
    </div>
  </div>
</div>

<ng-template #dateTemplate>
  <input
    #inputFieldToFocus
    type="text"
    class="form-control"
    [ngClass]="{
      disabled: isDisabled,
      'form-control-sm': this.size === 'small',
      'form-control-lg': this.size === 'large',
      'has-value': value !== null && value !== undefined && value !== '',
    }"
    [attr.id]="inputId"
    [attr.name]="name"
    [attr.data-testid]="name ? 'input-' + name : 'input'"
    [attr.placeholder]="placeholder"
    [disabled]="isDisabled"
    [readonly]="readonly || readonlyInput"
    [min]="minDate"
    [max]="maxDate"
    [matDatepicker]="datePicker"
    (click)="datePicker.open()"
    (focus)="onFocus()"
    [ngModel]="dateValue()"
    (ngModelChange)="emitChange($event)"
    (blur)="onBlur()"
    [ngbPopover]="inputInfoText"
    triggers="mouseenter:mouseleave"
  />
  <mat-datepicker [disabled]="isDisabled || readonly" #datePicker />
</ng-template>

<ng-template #defaultTemplate>
  @if (type === 'textArea') {
    <textarea
      #inputFieldToFocus
      class="form-control"
      [ngClass]="{
        disabled: isDisabled,
        'form-control-xs': this.size === 'xs',
        'form-control-sm': this.size === 'small',
        'form-control-lg': this.size === 'large',
        'has-value': value !== null && value !== undefined && value !== '',
      }"
      [attr.id]="inputId"
      [attr.name]="name"
      [attr.min]="min"
      [attr.max]="max"
      [attr.step]="stepSize"
      [attr.maxlength]="maxLength"
      [attr.minlength]="minLength"
      [attr.pattern]="pattern"
      [attr.placeholder]="placeholder"
      [attr.accept]="acceptFileTypes"
      [attr.multiple]="multipleFiles"
      [attr.autocomplete]="autocomplete"
      [attr.rows]="rows()"
      [disabled]="isDisabled"
      [readonly]="readonly"
      [ngModel]="value"
      (ngModelChange)="emitChange($event)"
      (focus)="focused.next()"
      (click)="clicked.emit()"
      (blur)="onBlur()"
      [attr.data-cy]="'input'"
      [attr.data-testid]="name ? 'input-' + name : 'input'"
      [ngbPopover]="inputInfoText"
      triggers="mouseenter:mouseleave"
    ></textarea>
  } @else {
    <input
      #inputFieldToFocus
      [type]="type"
      class="form-control"
      [ngClass]="{
        disabled: isDisabled,
        'text-end': type === 'number',
        'form-control-xs': this.size === 'xs',
        'form-control-sm': this.size === 'small',
        'form-control-lg': this.size === 'large',
        'has-value': value !== null && value !== undefined && value !== '',
      }"
      [attr.id]="inputId"
      [attr.name]="name"
      [attr.min]="min"
      [attr.max]="max"
      [attr.step]="stepSize"
      [attr.maxlength]="maxLength"
      [attr.minlength]="minLength"
      [attr.pattern]="pattern"
      [attr.placeholder]="placeholder"
      [attr.accept]="acceptFileTypes"
      [attr.multiple]="multipleFiles"
      [attr.autocomplete]="autocomplete"
      [disabled]="isDisabled"
      [readonly]="readonly"
      [ngModel]="value"
      (ngModelChange)="type === 'file' ? undefined : emitChange($event)"
      (change)="type === 'file' ? fileChange($event) : undefined"
      (focus)="focused.next()"
      (click)="clicked.emit()"
      (blur)="onBlur()"
      [attr.data-cy]="'input'"
      [attr.data-testid]="name ? 'input-' + name : 'input'"
      [ngbPopover]="inputInfoText"
      triggers="mouseenter:mouseleave"
    />
  }
</ng-template>

<ng-template #childrenPopover>
  <ng-content />
</ng-template>
